import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "view",
  id: "queryWrap"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Search "),
  /*#__PURE__*/_createElementVNode("span", null, "بحث")
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "searching", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "posts not found", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx, _cache) {
  const _component_Grid = _resolveComponent("Grid")
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.posts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.query)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "\" " + _toDisplayString(decodeURIComponent(_ctx.query)) + " \"", 1))
      : _createCommentVNode("", true),
    (_ctx.posts && _ctx.posts.length > 0)
      ? (_openBlock(), _createBlock(_component_Grid, {
          key: 2,
          posts: _ctx.posts.slice(0,_ctx.numMore)
        }, null, 8, ["posts"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
    (_ctx.posts && _ctx.numMore < _ctx.posts.length)
      ? (_openBlock(), _createElementBlock("a", {
          key: 4,
          href: "",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
        }, [
          (_ctx.LoadJSON)
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 0,
                ref: "loadCom",
                class: "loadMore",
                animationData: _ctx.LoadJSON,
                height: 115,
                width: 294,
                loop: true,
                autoPlay: false,
                onMouseover: _ctx.overAnim,
                onMouseout: _ctx.outAnim
              }, null, 8, ["animationData", "onMouseover", "onMouseout"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}